import { Link } from "react-router-dom";
import { EditableContent } from "./EditableContent";

export const Footer = () => (
  <>
    {/* Editable ad area — paste your Google ad code into public_html/content/ad.html */}
    <div data-testid="ad-slot" className="max-w-7xl mx-auto px-5 py-6 min-h-[100px] flex items-center justify-center">
      <EditableContent file="ad.html" executeScripts className="w-full text-center" />
    </div>
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-5 py-10 text-center">
        <div className="flex items-center justify-center gap-x-5 gap-y-2 flex-wrap text-sm text-slate-500">
          <Link to="/how-it-works" data-testid="footer-how" className="hover:text-navy">How It Works</Link>
          <Link to="/review-guidelines" data-testid="footer-guidelines" className="hover:text-navy">Review Guidelines</Link>
          <Link to="/renting-tips" data-testid="footer-tips" className="hover:text-navy">Renting Tips</Link>
          <Link to="/contact" data-testid="footer-contact" className="hover:text-navy">Contact</Link>
          <Link to="/privacy" className="hover:text-navy">Privacy</Link>
          <Link to="/terms" className="hover:text-navy">Terms</Link>
        </div>
        <EditableContent
          file="footer.html"
          className="tenverly-footer-text mt-4 text-xs text-slate-400 max-w-2xl mx-auto leading-relaxed"
          fallback={`<p>"Verified" means we have confirmed the reviewer held a tenancy at the address (they provided a tenancy agreement). Ratings and comments are the reviewer's own honest opinion and are not independently fact-checked by Tenverly.</p><p class="copyright">© 2026 Tenverly — All Rights Reserved</p>`}
        />
      </div>
    </footer>
  </>
);
